import { Roles } from "../interfaces";

export function getDescriptionPending(role: Roles, name: string) {
    switch (role) {
        case "GerenteR":
            return `Gerente regional pendente: ${name}`;
        case "GerenteS":
            return `Gerente de setor pendente: ${name}`;
        case "Representante":
            return `Representante pendente: ${name}`;
        case "Revendedor":
            return `Revendedor pendente: ${name}`;
        default:
            return `Cadastro pendente: ${name}`;
    }
}

export function getDescription(role: Roles | undefined, name: string) {
    switch (role) {
        case "GerenteR":
            return `Gerente regional: ${name}`;
        case "GerenteS":
            return `Gerente de setor: ${name}`;
        case "Representante":
            return `Representante: ${name}`;
        case "Revendedor":
            return `Revendedor: ${name}`;
        default:
            return `Cadastro: ${name}`;
    }
}
